import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=07d1c6f0&"
import script from "./MessageList.vue?vue&type=script&lang=js&"
export * from "./MessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d1c6f0')) {
      api.createRecord('07d1c6f0', component.options)
    } else {
      api.reload('07d1c6f0', component.options)
    }
    module.hot.accept("./MessageList.vue?vue&type=template&id=07d1c6f0&", function () {
      api.rerender('07d1c6f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/MessageList.vue"
export default component.exports